let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kekup")).then(() => parcelRequire('8iRAs'));